import React from 'react'
import { useParams } from 'react-router-dom'
import { PublicTicketShell } from 'page-components/auto-ticket/PublicTicketShell'
import { AuditTicketsListPage } from 'page-components/auto-ticket/AuditTicketsListPage'

export const TicketDigestScreen = () => {
    const { token } = useParams()

    return (
        <PublicTicketShell>
            <AuditTicketsListPage digestToken={token} layout="public" />
        </PublicTicketShell>
    )
}
